module.exports = __webpack_public_path__ + "img/show.2e52d4cd.svg";